<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listservices" class="blue-grey-text text-darken-4 strong">Security Master</router-link>
        >
        <span>Edit Service</span>
      </section>
    </article>
    <h4>
      Edit Service
    </h4>
    <article class="row">
      <section class="input-field col s2">
        <input type="number"
               placeholder="123456"
               class="validate"
               v-model="service.id"
               pattern="^[0-9]+$"
               disabled
        >
        <label class="active">Service ID</label>
      </section>
      <section class="input-field col s5">
        <input type="text"
                placeholder="e.g. Stock Advisor"
                class="validate"
                v-model="payload.name"
        >
        <label class="active">Name</label>
      </section>
      <section class="input-field col s5">
        <input type="number"
                placeholder=""
                class="validate"
                v-model="payload.product_id"
        >
        <label class="active">
          Product ID
          <span class="grey-text text-lighten-1">(Optional)</span>
        </label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s4">
        <select class="browser-default"
                v-model="payload.benchmark_id"
        >
          <option v-for="benchmark in benchmarks" :key="benchmark.id" :value="benchmark.id">
            {{ benchmark.name }} - {{ benchmark.symbol }}
          </option>
        </select>
        <label class="active">Benchmark</label>
      </section>
      <section class="input-field col s4">
        <select class="browser-default"
                v-model="payload.country_id"
        >
          <option v-for="country in countries" :key="country.id" :value="country.id">
            {{ country.name }} - {{ country.code }}
          </option>
        </select>
        <label class="active">Country</label>
      </section>
      <section class="input-field col s4">
        <select class="browser-default"
                v-model="payload.level"
        >
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
        </select>
        <label class="active">Level</label>
      </section>
    </article>
    <article class="row">
      <section class="col s9" />
      <section class="col s3">
        <input class="btn green waves-effect waves-light right"
                type="submit"
                value="Submit"
                @click.prevent="saveService"
        >
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';

const defaultPayload = {
  analyst_id: 0,
  service_id: 0,
  name: '',
  product_id: null,
  benchmark_id: 0,
  country_id: 0,
  level: null,
};

export default {
  name: 'TickerAdminEditService',
  components: {},
  props: {},
  data() {
    return {
      benchmarks: [],
      countries: [],
      service: {},
      payload: { ...defaultPayload },
    };
  },
  computed: {
    serviceId() {
      return Number(this.$route.query.service_id);
    },
    body() {
      const body = {
        service_id: this.payload.service_id,
        analyst_id: this.payload.analyst_id,
        country_id: this.payload.country_id,
        level: this.payload.level,
      };
      if (this.payload.name !== this.service.name) { body.name = this.payload.name.trim(); }
      if (this.payload.product_id !== this.service.product_id) { body.product_id = Number(this.payload.product_id); }
      if (this.payload.benchmark_id !== this.service.benchmark.id) { body.benchmark_id = this.payload.benchmark_id; }
      if (this.service.country) {
        if (this.payload.country_id !== this.service.country.id) { body.country_id = this.payload.country_id; }
      }
      if (this.payload.level !== this.service.level) { body.level = Number(this.payload.level); }

      return body;
    },
  },
  watch: {},
  methods: {
    async fetchMetadata() {
      const promises = [
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/benchmarks/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/countries/`),
      ];
      const [benchmarksResp, countriesResp] = await Promise.all(promises);
      [this.benchmarks, this.countries] = [benchmarksResp.data, countriesResp.data];
    },
    async fetchService() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/service/?service_id=${this.serviceId}`);
      this.service = data;
      this.payload.analyst_id = this.$auth.user.pk;
      this.payload.service_id = this.service.id;
      this.payload.name = this.service.name;
      this.payload.product_id = this.service.product_id;
      this.payload.benchmark_id = this.service.benchmark.id;
      if (this.service.country) {
        this.payload.country_id = this.service.country.id;
      }
      this.payload.level = this.service.level;
    },
    async saveService() {
      console.log(this.body);
      const usCountryId = 236;
      const requiredFields = [
        this.body.analyst_id,
        this.body.service_id,
        this.body.country_id,
      ];

      /*
        A service level is only required for US services; levels do not currently apply to
        international services. We require it when a US service is being created or edited so we
        don't have to track down the level on our end.
      */
      if (this.body.country_id === usCountryId) {
        requiredFields.push(this.body.level);
      }

      if (!requiredFields.every(arg => Boolean(arg))) {
        return this.toast('Please populate all required fields', 'pink');
      }

      if (String(Object.keys(this.body)) === String(['service_id', 'analyst_id'])) {
        return this.toast('Please modify at least one field', 'pink');
      }
      const { data } = await axios.put(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/service/`, this.body);
      this.toast(`Saved ${this.payload.name}!`, 'green');
      this.payload = { ...defaultPayload };
      this.fetchService();
    },
  },
  mounted() {
    this.fetchMetadata();
    this.fetchService();
  },
};
</script>
